
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Breed {
  id: string;
  name: string;
  display_name: string;
  active: boolean;
}

export const useBreeds = () => {
  return useQuery({
    queryKey: ['breeds'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('breeds')
        .select('id, name, display_name, active')
        .eq('active', true)
        .order('display_name');

      if (error) {
        console.error('Error fetching breeds:', error);
        throw error;
      }

      return data as Breed[];
    },
  });
};
